// extracted by mini-css-extract-plugin
module.exports = {"notOffers":"RequestBoats_notOffers__yVhbM","title":"RequestBoats_title__NC3oq","text":"RequestBoats_text__27Vsl"};